import operateLog from './operateLog';

export default operateLog;
